<template>
  <div class="cml-input-maxlength">
    <el-divider class="cml-divider" id="cml-divider" content-position="center"
      >{{ statusName }}单个膜布样品</el-divider
    >
    <el-form
      :disabled="formDisabled"
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="300px"
    >
      <el-form-item label="供应商" prop="supplierName">
        <el-input v-if="!['2', '1'].includes(this.$store.getters.userSelf.user.adminType) || status !== 'add'" disabled v-model.trim="formData.supplierName" />
        <SupplierSelect
          v-else
          :disabled="
            !['2', '1'].includes(this.$store.getters.userSelf.user.adminType) ||
            status !== 'add'
          "
          supplierType="MEMBRANE_CLOTH"
          :value="formData.supplierCode"
          @change-emit="supplierChange"
        />
      </el-form-item>
      <el-form-item label="产品名称" prop="productName">
        <el-input
          v-model.trim="formData.productName"
          :maxlength="maxlength"
          show-word-limit
        ></el-input>
        <span style="color: #AB0033; font-size: 12px; margin-left: 10px">
          克重+名称+材质
        </span>
      </el-form-item>
      <el-form-item label="生产产地" prop="productionCountryId">
        <CountrySelect
          :value="formData.productionCountryId"
          @change-emit="val => (formData.productionCountryId = val)"
        />
      </el-form-item>
      <el-form-item label="膜布类型" prop="fabricType">
        <DictSelect
          type="fabric_type"
          :value="formData.fabricType"
          @change-emit="value => (formData.fabricType = value)"
        />
      </el-form-item>
      <el-form-item label="膜布分类" prop="fabricCategory">
        <DictSelect
          type="fabric_category"
          :value="formData.fabricCategory"
          @change-emit="value => (formData.fabricCategory = value)"
        />
      </el-form-item>
      <el-form-item label="膜布重量（g）" prop="weight">
        <CustomNumInput
          :value="formData.weight"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.weight = val)"
        />
      </el-form-item>
      <el-form-item id="img-box" label="膜布材质" prop="materialQuality">
        <el-input
          v-model.trim="formData.materialQuality"
          :maxlength="maxlength"
          placeholder="例如：海藻纤维、天丝、锦纶等"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="膜布特点" prop="feature">
        <el-input
          v-model.trim="formData.feature"
          :maxlength="maxlength"
          placeholder="例如：柔软服帖、清洁、抗菌，轻薄隐形等"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="日产能（片）" prop="dailyCapacity">
        <CustomNumInput
          :value="formData.dailyCapacity"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.dailyCapacity = val)"
        />
      </el-form-item>
      <el-form-item label="建议吸液量（ml）" prop="suggestVolume">
        <CustomNumInput
          :value="formData.suggestVolume"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.suggestVolume = val)"
        />
      </el-form-item>
      <el-form-item label="可视化实验" prop="visualizationExperiment">
        <el-input
          v-model.trim="formData.visualizationExperiment"
          :maxlength="maxlength"
          placeholder="例如：发光实验，煅烧实验等"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="是否可印图案" prop="printablePattern">
        <DictSelect
          type="cml_common_whether"
          :value="formData.printablePattern"
          @change-emit="value => (formData.printablePattern = value)"
        />
      </el-form-item>
      <el-form-item label="是否可压实物" prop="compressibleObject">
        <DictSelect
          type="cml_common_whether"
          :value="formData.compressibleObject"
          @change-emit="value => (formData.compressibleObject = value)"
        />
      </el-form-item>
      <el-form-item label="主图片" class="img-box" required prop="mainImage">
        <span class="example-img" v-if="status !== 'detail'">
          <span>
            <b>图片示例</b><br />
          </span>
          <el-image 
            src="https://oss.syounggroup.com/static/file/cml-main-service/example/mobu01.png" 
            :preview-src-list="['https://oss.syounggroup.com/static/file/cml-main-service/example/mobu01.png']">
          </el-image>
        </span>
        <UploadImage
          v-if="showUploadImage"
          ref="uploadImage"
          :disabled="formDisabled"
          :status="status"
          :imgUrl="formData.mainImage"
          @img-change="mainImageChange"
        />
      </el-form-item>
      <el-form-item label="材质细节图片" class="img-box" required prop="detailImages">
        <span class="example-img" v-if="status !== 'detail'">
          <span>
            <b>图片示例</b><br />
          </span>
          <el-image 
            src="https://oss.syounggroup.com/static/file/cml-main-service/example/mobu02.png" 
            :preview-src-list="['https://oss.syounggroup.com/static/file/cml-main-service/example/mobu02.png']">
          </el-image>
        </span>
        <UploadImageList
          v-if="showUploadImage"
          ref="UploadImageList"
          :disabled="formDisabled"
          @img-change="detailImagesListChange"
        />
      </el-form-item>
      <el-form-item label="是否有专利" prop="havePatent">
        <DictSelect
          type="cml_common_whether"
          :value="formData.havePatent"
          @change-emit="value => (formData.havePatent = value)"
        />
      </el-form-item>
      <el-form-item label="预估含税单价（元/片）" prop="price">
        <CustomNumInput
          :value="formData.price"
          :maxlength="7"
          :limitNum="3"
          :isNegativeFloat="true"
          @change-emit="val => (formData.price = val)"
        />
      </el-form-item>
      <el-form-item label="生产周期（天）" prop="productionCycle">
        <CustomNumInput
          :value="formData.productionCycle"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.productionCycle = val)"
        />
      </el-form-item>
      <el-form-item label="正式订单的最低起订量（张）" prop="minNum">
        <CustomNumInput
          :value="formData.minNum"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.minNum = val)"
        />
      </el-form-item>
      <el-form-item label="是否做过大货生产" prop="haveMassProduction">
        <DictSelect
          type="cml_common_whether"
          :value="formData.haveMassProduction"
          @change-emit="haveMassProductionChange"
        />
      </el-form-item>
      <el-form-item v-if="formData.haveMassProduction === 'YES'" label="已使用品牌" prop="brandsUsed">
        <el-input
          v-model.trim="formData.brandsUsed"
          :maxlength="maxlength"
          show-word-limit
          placeholder="多个品牌请用逗号隔开"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-if="formData.haveMassProduction === 'NO'"
        label="开发进度"
        prop="developmentProgress"
      >
        <el-input
          v-model.trim="formData.developmentProgress"
          :maxlength="maxlength"
          show-word-limit
          placeholder="请说明开发进度"
        ></el-input>
      </el-form-item>
      <el-form-item label="样品的发货时间" prop="deliveryTime">
        <CustomNumInput
          :value="formData.deliveryTime"
          :maxlength="7"
          :limitNum="0"
          @change-emit="val => (formData.deliveryTime = val)"
        />
        天内
      </el-form-item>
      <el-form-item label="是否被水羊启用过" prop="shuiyangEnable">
        <DictSelect
          type="cml_common_whether"
          :value="formData.shuiyangEnable"
          @change-emit="value => (formData.shuiyangEnable = value)"
        />
      </el-form-item>
      <el-form-item label="附件" required>
        <UploadFile
          :disabled="formDisabled"
          ref="uploadFile"
          :maxSize="100"
          :excelFileExtend="'.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.jpg,.png,.jpeg'"
          btnName="膜布介绍资料"
          showTips="支持DOC、DOCX、PDF、XLS、XLSX、PPT、PPTX、JPG、PNG、JPEG格式文件"
        />
      </el-form-item>
      <el-form-item label="产品详情" id="editor-box" prop="information">
        <TextareaEditor :disabled="formDisabled" ref="textareaEditor" />
      </el-form-item>
    </el-form>

    <span
      v-if="!formDisabled && status !== 'verify'"
      style="margin: 20px 0 50px 300px"
    >
      <el-button size="medium" :loading="saveLoading" @click="saveBtn"
        >保存草稿</el-button
      >
      <el-button
        type="primary"
        size="medium"
        style="margin-left: 50px"
        :loading="saveLoading"
        @click="submitBtn"
        >提交审核</el-button
      >
    </span>

    <SubmitDialog
      :dialogVisible="dialogVisible"
      @create-again="createAgain"
      @to-sample-page="toSamplePage"
    />

    <!-- 审核 -->
    <VerifyComponent
      ref="verifyComponent"
      :status="status"
      :statusName="statusName"
      :saveLoading="saveLoading"
      @verify-btn="verifyBtn"
    />
  </div>
</template>
<script>
import CountrySelect from '@/components/CountrySelect';
import SupplierSelect from '@/components/SupplierSelect';
import DictSelect from '@/components/DictSelect';
import UploadImage from '@/components/Upload/UploadImage.vue';
import UploadFile from '@/components/Upload/UploadFile.vue';
import CustomNumInput from '@/components/CustomNumInput';
import TextareaEditor from '@/components/TextareaEditor';
import VerifyComponent from '../sample-component/VerifyComponent.vue';
import SubmitDialog from '../sample-component/SubmitDialog.vue';
import sampleCreate from '@/mixins/sampleCreate';
import UploadImageList from '@/components/Upload/UploadImageList.vue';

export default {
  name: 'publish-membrane-sample',
  components: {
    CountrySelect,
    SupplierSelect,
    DictSelect,
    UploadImage,
    UploadFile,
    CustomNumInput,
    TextareaEditor,
    VerifyComponent,
    SubmitDialog,
    UploadImageList
  },
  mixins: [sampleCreate],
  data() {
    const mainImageValid = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择主图片'));
      } else {
        callback();
      }
    };
    const detailImagesValid = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请选择材质细节图片'));
      } else {
        callback();
      }
    };
    return {
      formData: {
        sampleId: '',
        id: '',
        supplierCode: '',
        supplierName: '',
        productName: '',
        productionCountryId: '',
        fabricType: '',
        fabricCategory: '',
        weight: '',
        materialQuality: '',
        feature: '',
        dailyCapacity: '',
        suggestVolume: '',
        visualizationExperiment: '',
        printablePattern: '',
        compressibleObject: '',
        imgUrl: '',
        havePatent: '',
        price: '',
        productionCycle: '',
        minNum: '',
        haveMassProduction: '',
        brandsUsed: '',
        developmentProgress: '',
        deliveryTime: '',
        shuiyangEnable: '',
        information: '',
        mainImage: '',
        detailImages: []
      },
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
        ],
        fabricType: [
          { required: true, message: '请选择膜布类型', trigger: 'change' },
        ],
        fabricCategory: [
          { required: true, message: '请选择膜布分类', trigger: 'change' },
        ],
        weight: [
          { required: true, message: '请输入膜布重量', trigger: 'blur' },
        ],
        materialQuality: [
          { required: true, message: '请输入膜布材质', trigger: 'blur' },
        ],
        feature: [
          { required: true, message: '请输入膜布特点', trigger: 'blur' },
        ],
        dailyCapacity: [
          { required: true, message: '请输入日产能', trigger: 'blur' },
        ],
        suggestVolume: [
          { required: true, message: '请输入建议吸液量', trigger: 'blur' },
        ],
        mainImage: [{ validator: mainImageValid, trigger: 'blur' }],
        detailImages: [{ type: 'array', validator: detailImagesValid, trigger: 'change' }],
        visualizationExperiment: [
          { required: true, message: '请输入可视化实验', trigger: 'blur' },
        ],
        printablePattern: [
          { required: true, message: '请选择是否可印图案', trigger: 'change' },
        ],
        compressibleObject: [
          { required: true, message: '请选择是否可压实物', trigger: 'change' },
        ],
        havePatent: [
          { required: true, message: '请选择是否有专利', trigger: 'change' },
        ],
        price: [
          { required: true, message: '请输入预估含税单价', trigger: 'blur' },
        ],
        productionCycle: [
          { required: true, message: '请输入生产周期', trigger: 'blur' },
        ],
        minNum: [
          {
            required: true,
            message: '请输入正式订单的最低起订量',
            trigger: 'blur',
          },
        ],
        haveMassProduction: [
          {
            required: true,
            message: '请选择是否做过大货生产',
            trigger: 'change',
          },
        ],
        deliveryTime: [
          { required: true, message: '请输入样品的发货时间', trigger: 'blur' },
        ],
        shuiyangEnable: [
          {
            required: true,
            message: '请选择是否被水羊启用过',
            trigger: 'change',
          },
        ],
      },
      maxlength: 30,
      saveLoading: false,
      status: 'add',
      statusName: '新增',
      formDisabled: false,
      dialogVisible: false,
      row: { id: '' },
      id: '',
      showUploadImage: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkQueryParams(vm);
    });
  },
  mounted() {
    const { code, name } = this.$store.getters.userSupplier;
    if (code) {
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    }
  },
  methods: {
    getDetail() {
      this.$http.sampleManage
        .getFabric(this.id)
        .then(result => {
          for (let i in this.formData) {
            this.formData[i] = result.data[i];
          }
          this.formData.sampleId = this.row.id;
          this.$refs.uploadFile.fileList = (result.data.sampleAttachmentVOs || []).map(
            item => {
              return {
                fileName: item.name,
                fileUrl: item.url,
              };
            },
          );
          this.$nextTick(()=> {
            this.$refs.UploadImageList.setFileListData(this.formData.detailImages || []);
          })
          // 设置textarea内容
          this.$refs.textareaEditor.setHtml(result.data.information);
        })
        .catch(err => {
          this.$message.error(err.msg);
        });
    },
    haveMassProductionChange(val) {
      this.formData.haveMassProduction = val;
      this.formData.brandsUsed = '';
      this.formData.developmentProgress = '';
    },
    checkParams() {
      let state = true;
      if (!this.formData.mainImage) {
        this.$message.error('请选择主图片');
        state = false;
        return;
      }
      if (this.formData.detailImages.length === 0) {
        this.$message.error('请选择材质细节图片');
        state = false;
        return;
      }
      if (this.$refs.uploadFile.fileList.length < 1) {
        this.$message.error('请添加膜布介绍资料');
        state = false;
        return;
      }
      const { imgUrls, text } = this.$refs.textareaEditor.getHtml();
      if (imgUrls.length > 20) {
        this.$message.error('产品详情最多可以上传20张图片');
        state = false;
        return;
      }
      if (text.length > 5000) {
        this.$message.error('产品详情最多可以输入5000个字符');
        state = false;
        return;
      }
      return state;
    },
    saveBtn(val) {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          if (this.checkParams()) {
            const { allHtml } = this.$refs.textareaEditor.getHtml();
            let params = { ...this.formData };
            
            const $url = ['add', 'copy'].includes(this.status) ? 'createFabric' : 'updateFabric';
            const AttachmentCmdList = ['add', 'copy'].includes(this.status) ? 'createSampleAttachmentCmdList' : 'updateSampleAttachmentCmdList';
            if(['add', 'copy'].includes(this.status)) {
              delete params.id;
              delete params.sampleId;
            }

            params.information = allHtml.trim();
            // 删除小数末尾的小数点
            this.deleteLastDot(params, ['price']);
            // 附件
            params[AttachmentCmdList] = this.$refs.uploadFile.fileList.map(
              item => {
                return {
                  name: item.fileName,
                  sampleId: ['add', 'copy'].includes(this.status) ? '' : this.formData.sampleId,
                  type: 'FABRIC_INTRO',
                  url: item.fileUrl,
                };
              },
            );

            try {
              // 保存
              const msg = await this.saveParams($url, params);
              // 提交
              if (val === 'submit') {
                this.$http.sampleManage
                  .batchSubmitSample([this.row.id])
                  .then(result => {
                    if (result.data.failNum > 0) {
                      this.$message.error(
                        result.data.failResultList[0].code +
                          result.data.failResultList[0].msg,
                      );
                    } else {
                      this.dialogVisible = true;
                    }
                  })
                  .catch(err => {
                    this.$message.error(err.msg);
                  })
                  .finally(() => {
                    this.saveLoading = false;
                  });
              } else {
                if (['add', 'copy', 'update'].includes(this.status)) {
                  this.$message.success(msg);
                  this.toSamplePage('submitSuccessToHistoryTab1');
                } else if (this.status === 'verify') {
                  // 审核
                  const params = {
                    ...this.$refs.verifyComponent.verifyFormData,
                  };
                  params.sampleId = this.row.id;
                  this.saveLoading = true;
                  this.$http.sampleManage
                    .createSampleCheck(params)
                    .then(result => {
                      this.$message.success(result.msg);
                      this.toSamplePage(
                        'toListTab1',
                        'sample-manage/verify-sample',
                        '审核样品',
                      );
                    })
                    .catch(err => {
                      this.$message.error(err.msg);
                    })
                    .finally(() => {
                      this.saveLoading = false;
                    });
                }
              }
            } catch (err) {
              this.$message.error(err);
            }
          }
        } else {
          this.$message.error('必填项不能为空，请认真检查哦！');
          this.pageScrollToTop();
          return false;
        }
      });
    },
    saveParams($url, params) {
      return new Promise((reslove, reject) => {
        this.saveLoading = true;
        this.$http.sampleManage[$url](params)
          .then(result => {
            // code=-1，错误提示
            if(result.data.code && result.data.code == -1) {
              reject(result.data.msg);
              return;
            }
            if (['add', 'copy'].includes(this.status)) {
              this.row.id = result.data;
            }
            reslove(result.msg);
          })
          .catch(err => {
            reject(err.msg);
          })
          .finally(() => {
            this.saveLoading = false;
          });
      });
    },
    resetForm() {
      this.showUploadImage = false;
      this.$nextTick(() => {
        this.showUploadImage = true;
      });
      this.status = 'add';
      this.statusName = '新增';
      this.row = { id: '' };
      this.$refs.formData.resetFields();
      this.formData.mainImage = '';
      this.$refs.textareaEditor.clear();
      this.$refs.uploadFile.fileList = [];
      const { code, name } = this.$store.getters.userSupplier;
      this.formData.supplierCode = code;
      this.formData.supplierName = name;
    },
    mainImageChange(val) {
      this.formData.mainImage = val;
      if (val) {
        this.$refs.formData.clearValidate('mainImage');
      } else {
        this.$refs.formData.validateField('mainImage');
      }
    },
    detailImagesListChange (val) {
      this.formData.detailImages = val;
      if (val) {
        this.$refs.formData.clearValidate('detailImages');
      } else {
        this.$refs.formData.validateField('detailImages');
      }
    },
    supplierChange(val, name) {
      this.formData.supplierCode = val;
      this.formData.supplierName = name;
    },
  },
};
</script>
